import { Box, Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectAnnouncementsState } from '../sagas/announcementSlice';
import { convertToHumanReadable } from '../../../utils/string-util';
import { format, parseISO } from 'date-fns';
import { generateRecurringAnnouncementSentence } from './utils/utils';
import { AnnouncementFrequencies } from '@inosio/payments-sdk';

interface IProps {
  isComplete: boolean;
}

export const AnnouncementReview = (props: IProps) => {
  const { announcementDetail } = useSelector(selectAnnouncementsState);
  const labelStyle = {
    fontSize: '14px',
    fontWeight: 'bold',
  };



  return (
    <Box sx={{ padding: 2 }}>
      <Grid container spacing={3}>
        <Grid item xs={8} borderRight="2px solid #EEEEEE">
          {/* Send From Section */}
          <Grid container spacing={1} sx={{ marginBottom: 2 }}>
            <Grid item xs={2}>
              <Typography sx={labelStyle}>Send From:</Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography variant="body1">{announcementDetail?.SenderIdentity?.Email}</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={1} sx={{ marginBottom: 2 }}>
            <Grid item xs={2}>
              <Typography sx={labelStyle}>Send On:</Typography>
            </Grid>
            <Grid item xs={10}>
              {announcementDetail.FirstSendDatetime && announcementDetail.Frequency === AnnouncementFrequencies.OneTime ? (
                <Typography variant="body1">{format(parseISO(announcementDetail.FirstSendDatetime)!, 'MM/dd/yyyy hh:mm a')}</Typography>
              ) : (
                generateRecurringAnnouncementSentence(announcementDetail)
              )}
            </Grid>
          </Grid>

          <Grid container spacing={1} sx={{ marginBottom: 2 }}>
            <Grid item xs={2}>
              <Typography sx={labelStyle}>Subject:</Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography variant="body1">{announcementDetail.Subject}</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={1} sx={{ marginBottom: 2 }}>
            <Grid item xs={2}>
              <Typography sx={labelStyle}>Message:</Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography variant="body1" dangerouslySetInnerHTML={{ __html: announcementDetail.Body }}></Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={4} sx={{ flexGrow: 1, overflowY: 'auto', flexDirection: 'column', height: 'calc(100vh - 220px)' }}>
          <Typography sx={labelStyle}>Send To:</Typography>
          {announcementDetail?.RecipientOptions?.map((recipient) => (
            <Box sx={{ marginBottom: 0 }} key={recipient}>
              <Typography variant="body2">{convertToHumanReadable(recipient)}</Typography>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};
